import { AppUser } from './app-user.model';

export class IdentitySession {
    sessionToken: any;
    jwtToken: any;
    user: AppUser;
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/model/identity-session.model.ts